export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/[...all].vue'),
    /* no children */
    meta: {
      "layout": 404
    }
  },
  {
    path: '/bank-statement',
    /* internal name: '/bank-statement' */
    /* no component */
    children: [
      {
        path: '',
        name: '/bank-statement/',
        component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/bank-statement/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/company',
    /* internal name: '/company' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/company/[id]',
        component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/company/[id].vue'),
        /* no children */
      },
      {
        path: 'solfacil',
        /* internal name: '/company/solfacil' */
        /* no component */
        children: [
          {
            path: '',
            name: '/company/solfacil/',
            component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/company/solfacil/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/customer',
    /* internal name: '/customer' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/customer/[id]',
        component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/customer/[id].vue'),
        /* no children */
      },
      {
        path: 'solfacil',
        /* internal name: '/customer/solfacil' */
        /* no component */
        children: [
          {
            path: '',
            name: '/customer/solfacil/',
            component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/customer/solfacil/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/installation',
    /* internal name: '/installation' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/installation/[id]',
        component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/installation/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/minha-carteira',
    /* internal name: '/minha-carteira' */
    /* no component */
    children: [
      {
        path: '',
        name: '/minha-carteira/',
        component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/minha-carteira/index.vue'),
        /* no children */
        meta: {
          "layout": "default"
        }
      }
    ],
  },
  {
    path: '/projects',
    /* internal name: '/projects' */
    /* no component */
    children: [
      {
        path: '',
        name: '/projects/',
        component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/projects/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/simulation',
    /* internal name: '/simulation' */
    /* no component */
    children: [
      {
        path: 'details',
        /* internal name: '/simulation/details' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/simulation/details/[id]',
            component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/simulation/details/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'new',
        /* internal name: '/simulation/new' */
        /* no component */
        children: [
          {
            path: '',
            name: '/simulation/new/',
            component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/simulation/new/index.vue'),
            /* no children */
          },
          {
            path: 'waiting',
            name: '/simulation/new/waiting',
            component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/simulation/new/waiting.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'result',
        /* internal name: '/simulation/result' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/simulation/result/[id]',
            component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/simulation/result/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'revision',
        /* internal name: '/simulation/revision' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/simulation/revision/[id]',
            component: () => import('/home/runner/_work/pr.sim.financial-products-simulator-frontend/pr.sim.financial-products-simulator-frontend/src/pages/simulation/revision/[id].vue'),
            /* no children */
          }
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

